import { REREAD_ENABLED } from '../../brand/flags/reread';
import { startMountedReread, type RereadStartOptions } from './revisitSession';

export interface RevisitController {
  /**
   * Starts "Re-read my sources" from revisit step 1 (Next), with any sources the person changed there,
   * resolving once the wizard may move on. null while re-reading does not exist: Next then goes to step 2
   * like Edit manually.
   */
  onStart: ((options?: RereadStartOptions) => Promise<void>) | null;
}

const REREAD: RevisitController = { onStart: startMountedReread };
const NO_REREAD: RevisitController = { onStart: null };

/**
 * Re-reading in a revisit (Release 4, lane W7). The wizard's state machine calls this above the providers
 * it renders, so `onStart` reaches the wizard's RevisitProvider through revisitSession.ts. It resolves
 * once the server took the re-read (the wizard then moves to step 2, where the banner shows it running),
 * and rejects when it was refused, keeping the wizard on step 1 with the reason in the banner.
 */
export function useRevisitController(): RevisitController {
  return REREAD_ENABLED ? REREAD : NO_REREAD;
}
